export const divisions = [{ label: 'D-I' }, { label: 'D-II' }, { label: 'D-III' }];
